import {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import Footer from "../../components/footer";
import Header from "../../components/header";
import {
  useSearchParams,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
// import { UserPlus, UserCheck, UserX } from "lucide-react";
import AdminImg from "../../assets/admin.png";
import bgImage from '../../assets/backgroundvector.jpg'
import EditYourProfile from "../../components/EditYourProfile";
import Publication from "../../pages/publications/publication";
import Video from "../../pages/video/video";
import Gallery from "../../pages/images/image";
import Code from "../../pages/codesnippet/code";
import Portfolio from "../../pages/portfolio/portfolio";
import axios from "axios";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { useProfile } from "../../context/ProfileContext";
import MobileHeader from "../../components/MobileHeader";
import { useMediaQuery } from "react-responsive";
import ResearchSuggestionDropdown from "../../components/ResearchSuggestionDropdown";
import DropdownActions from "../../components/DropdownActions";
import websocketClient from "../../utils/websocketClient";
import Invitations from "../invitations/Invitations";
import Posts from "../posts/Posts";
import Jobs, { getExperienceLabel } from "../jobs/Jobs";
import useCurrentTeacher from "../../hooks/useCurrentTeacher";
import { htmlToText } from 'html-to-text';
import CodeHighlighter from "../../components/CodeHighlighter";
import FileViewer from "../marketplace/FileViewer";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const x_api_key = process.env.REACT_APP_X_API_KEY;

const VALID_TABS = [
  "portfolio",
  "publications",
  "gallery",
  "videos",
  "code",
  "invitations",
  "posts",
  "jobs",
];

const ProfileView = () => {
  const location = useLocation()
  const pathname = location.pathname;

  const [isTeacher, setIsTeacher] = useState(false);
  const [teacherId, setTeacherId] = useState(null); // new state
  const { isTeacher: is_Teacher, teacher } = useCurrentTeacher()
  // console.log("The teacher is:",isTeacher)
  const token = localStorage.getItem("access_token");
  const { profileId: contextId } = useProfile();
  const [loading, setLoading] = useState(false);
  const [allLoading, setAllLoading] = useState(false);
  const params = useParams();
  const routeProfileId = params.id || params.userId;
  const navigate = useNavigate();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");
  const [editMode, setEditMode] = useState("fullProfile");
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const [profile, setProfile] = useState(null);
  // console.log("The user profile is:",profile)
  const [apiError, setApiError] = useState("");
  const [allPosts, setAllPosts] = useState([]);
  const [publications, setPublications] = useState([]);
  const [loadingPublications, setLoadingPublications] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isFollowing, setIsFollowing] = useState(null);
  const tabFromUrl = searchParams.get("tab");
  const [currentUser, setCurrentUser] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState("");
  const [editingPostId, setEditingPostId] = useState(null);
  const [editingType, setEditingType] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const seenIdsRef = useRef(new Set());
  const [editVisibility, setEditVisibility] = useState("public");
  const [isPending, setIsPending] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [isReceiver, setIsReceiver] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [showFollowersModal, setShowFollowersModal] = useState(false);
  const [showConnectionsModal, setShowConnectionsModal] = useState(false);
  const [followersList, setFollowersList] = useState([]);
  const [connectionsList, setConnectionsList] = useState([]);
  const [followersLoading, setFollowersLoading] = useState(false);
  const [connectionsLoading, setConnectionsLoading] = useState(false);
  const [followersCount, setFollowersCount] = useState(0);
  const [connectionsCount, setConnectionsCount] = useState(0);
  const dropdownRefs = useRef({});
  const profileId = routeProfileId || contextId;
  const displayFollowersCount = routeProfileId ? followersCount : profile?.total_followers || 0;

  const isYourOwnProfile = useMemo(() => {
    if (profileId == null || contextId == null) return false;
    return Number(profileId) === Number(contextId);
  }, [profileId, contextId]);
  useEffect(() => {
    if (!routeProfileId) return;

    const checkIsTeacher = async () => {
      try {
        const res = await fetch(`${BASE_URL}/teacher/${routeProfileId}/is_teacher/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        });
        const data = await res.json();
        setIsTeacher(data.is_teacher); // true/false
        setTeacherId(data.teacher_id || null); // set teacher_id or null
      } catch (err) {
        console.error("API call failed:", err);
        setIsTeacher(false);
        setTeacherId(null);
      }
    };

    checkIsTeacher();
  }, [routeProfileId]);

  useEffect(() => {
    if (currentUserId && profile) {
      fetchRequests();
    }
  }, [currentUserId, profile]);

  useEffect(() => {
    if (profileId) {
      checkConnection();
    }

  }, [profileId]);

  const fetchCurrentUser = useCallback(async () => {
    if (currentUser) return; // 🔥 prevents re-calls

    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },

      });

      const data = await res.json();
      if (res.ok) {
        setCurrentUser(data.data);
        setCurrentUserId(data.data?.user);
        localStorage.setItem("user_id", data.data?.user);
      }
    } catch (err) {
      toast.error("Error retrieving user info.");
    } finally {
      setLoading(false);
    }
  }, [token, currentUser]);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  useEffect(() => {
    if (!tabFromUrl) return;

    if (VALID_TABS.includes(tabFromUrl)) {
      setSelectedTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  useEffect(() => {
    const fetchPublications = async () => {
      if (!loadingPublications) return;

      try {
        const res = await fetch(`${BASE_URL}/user/publication/publication/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        });

        const data = await res.json();
        if (res.ok) {
          setPublications(data.data || []);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingPublications(false);
      }
    };
    fetchPublications();
  }, [loadingPublications]);

  const fetchUserPosts = useCallback(async (url) => {
    if (!profileId || !url) return;

    setAllLoading(true);
    try {
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });
      const data = await res.json();
      if (res.ok && data.data) {
        const combined = [
          ...(data.data.publications || []).map((p) => ({ ...p, type: "publication" })),
          ...(data.data.gallery_images || []).map((p) => ({ ...p, type: "image" })),
          ...(data.data.videos || []).map((p) => ({ ...p, type: "video" })),
          ...(data.data.user_codes || []).map((p) => ({ ...p, type: "code" })),
          ...(data.data.posts || []).map((p) => ({ ...p, type: "post" })),
          ...(data.data.portfolio ? [{ ...data.data.portfolio, type: "portfolio" }] : []),
        ];

        const filtered = combined.filter((post) => {
          if (seenIdsRef.current.has(post.id)) return false;
          seenIdsRef.current.add(post.id);
          return true;
        });

        setAllPosts(filtered);
        setHasMore(false);
      }
    } catch (err) {
      toast.error("Error fetching posts.");
    } finally {
      setAllLoading(false);
    }
  }, [profileId]);


  useEffect(() => {
    if (!profileId || !localStorage.getItem("access_token")) return;
    if (selectedTab === "all" && profileId) {
      setAllPosts([]);
      seenIdsRef.current.clear();
      const firstUrl = `${BASE_URL}/user/profile/all-profiles?id=${profileId}`;
      setNextPageUrl(firstUrl);
      fetchUserPosts(firstUrl);
    }
  }, [selectedTab, profileId, BASE_URL, fetchUserPosts]);

  const loaderRef = useRef(null);

  useEffect(() => {
    if (!loaderRef.current || !hasMore || allLoading) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && nextPageUrl) {
          fetchUserPosts(nextPageUrl);
        }
      },
      { rootMargin: "300px" }
    );

    observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [hasMore, nextPageUrl, allLoading, fetchUserPosts]);

  const fetchProfile = useCallback(async () => {
    if (!profileId) return;
    if (profile && profile.id === profileId) return; // 🔥 prevent refetch

    try {
      setApiError("");

      const url = routeProfileId
        ? `${BASE_URL}/user/profile/all-profiles/?id=${profileId}`
        : `${BASE_URL}/user/profile/create-profile`;

      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const data = await res.json();
      console.log("The profile data is:", data)
      if (!res.ok) throw new Error(data.message);

      setProfile(data.data);
    } catch (err) {
      setApiError(err.message);
    }
  }, [profileId, routeProfileId, profile]);

  useEffect(() => {
    fetchProfile();
  }, [profileId]);

  useEffect(() => {
    if (profile?.id) {
      fetchFollowStatus();
    }
  }, [profile?.id]);


  const handleEditClick = (post) => {
    setEditingPostId(post.id);
    setEditingType(post.type);
    setEditText(post.description || post.title || "");
    setIsEditing(true);
    setEditVisibility(post.visibility || "public");
  };
  const handleDeletePost = async (postId, type) => {
    let url;
    if (type === "image") url = `${BASE_URL}/user/gallery/gallery-images/`;
    else if (type === "video") url = `${BASE_URL}/user/videos/video/`;
    else if (type === "code") url = `${BASE_URL}/user/code/code/`;
    else if (type === "publication")
      url = `${BASE_URL}/user/publication/publication/`;
    else if (type === "post") url = `${BASE_URL}/user/posts/`;
    else {
      toast.error("Unknown post type");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("id", postId);
      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },

        data: formData,
      });
      setAllPosts((prev) => prev.filter((p) => p.id !== postId));
      toast.success("Post deleted successfully");
    } catch (error) {
      console.error("Error deleting post:", error.response || error);
      toast.error("Failed to delete post");
    } finally {
    }
  };
  const handleSaveEdit = async () => {
    if (!editingPostId || !editingType) {
      toast.error("Missing post type or ID");
      return;
    }

    let url;
    if (editingType === "image")
      url = `${BASE_URL}/user/gallery/gallery-images/`;
    else if (editingType === "video") url = `${BASE_URL}/user/videos/video/`;
    else if (editingType === "code") url = `${BASE_URL}/user/code/code/`;
    else if (editingType === "publication")
      url = `${BASE_URL}/user/publication/publication/`;
    else if (editingType === "post") url = `${BASE_URL}/user/posts/`;
    else {
      toast.error("Unknown post type");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", editingPostId);
      formData.append("description", editText);
      formData.append("visibility", editVisibility);
      await axios.patch(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      setAllPosts((prev) =>
        prev.map((p) =>
          p.id === editingPostId ? { ...p, description: editText } : p
        )
      );

      toast.success("Post updated successfully");
      setIsEditing(false);
      setEditingPostId(null);
      setEditingType(null);
    } catch (error) {
      console.error("Error editing post:", error.response || error);
      toast.error("Failed to update post");
    }
  };
  const handleCoverUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("cover_image", file);
    try {
      const response = await axios.post(
        `${BASE_URL}/user/profile/profile-cover-image/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      toast.success("Cover image updated!");
      fetchProfile();
    } catch (error) {
      toast.error("Failed to upload cover image.");
      console.error("Cover image upload error:", error);
    }
  };

  const fetchFollowers = useCallback(async (targetProfileId = routeProfileId || contextId) => {
    if (!targetProfileId) return;
    setFollowersLoading(true);

    try {
      const res = await axios.get(`${BASE_URL}/user/follow-unfollow/followers-by-user/?id=${targetProfileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const followers = (res.data.results || [])
        .map((item) => item.follow_user_profile)
        .filter(Boolean);

      setFollowersCount(res.data.count || 0);
      setFollowersList(followers);
    } catch (error) {
      console.error("Error fetching followers:", error);
      setFollowersCount(0);
      setFollowersList([]);
    } finally {
      setFollowersLoading(false);
    }
  }, [routeProfileId, contextId, token]);

  const fetchFollowersCount = useCallback(async (targetProfileId = routeProfileId || contextId) => {
    if (!targetProfileId) {
      setFollowersCount(routeProfileId ? 0 : profile?.total_followers || 0);
      return;
    }

    try {
      const res = await axios.get(`${BASE_URL}/user/follow-unfollow/followers-by-user/?id=${targetProfileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });
      setFollowersCount(res.data.count || 0);
    } catch (error) {
      console.error("Error fetching follower count:", error);
      setFollowersCount(0);
    }
  }, [routeProfileId, contextId, profile, token]);

  useEffect(() => {
    if (routeProfileId) {
      fetchFollowersCount(routeProfileId);
    } else if (profile) {
      setFollowersCount(profile.total_followers || 0);
    }
  }, [routeProfileId, profile, contextId, fetchFollowersCount]);

  useEffect(() => {
    if (!showFollowersModal) return;
    fetchFollowers(routeProfileId || contextId);
  }, [showFollowersModal, routeProfileId, contextId, fetchFollowers]);

  const fetchConnections = useCallback(async (targetProfileId = routeProfileId || contextId) => {
    if (!targetProfileId) return;
    setConnectionsLoading(true);

    try {
      const res = await axios.get(`${BASE_URL}/user/chat/connected-profiles-by-user-id/?id=${targetProfileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      const results = res.data?.results || [];
      setConnectionsList(results);
      setConnectionsCount(res.data?.count ?? results.length);
    } catch (error) {
      console.error("Error fetching connections:", error);
      setConnectionsList([]);
      setConnectionsCount(0);
    } finally {
      setConnectionsLoading(false);
    }
  }, [routeProfileId, contextId, token]);

  useEffect(() => {
    if (!showConnectionsModal) return;
    fetchConnections(routeProfileId || contextId);
  }, [showConnectionsModal, routeProfileId, contextId, fetchConnections]);

  const fetchConnectionsCount = useCallback(async (targetProfileId = routeProfileId || contextId) => {
    if (!targetProfileId) {
      setConnectionsCount(routeProfileId ? 0 : profile?.total_connections || 0);
      return;
    }

    try {
      const res = await axios.get(`${BASE_URL}/user/chat/connected-profiles-by-user-id/?id=${targetProfileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });
      setConnectionsCount(res.data?.count ?? (res.data?.results || []).length);
    } catch (error) {
      console.error("Error fetching connections count:", error);
      setConnectionsCount(0);
    }
  }, [routeProfileId, contextId, profile, token]);

  useEffect(() => {
    if (routeProfileId) {
      fetchConnectionsCount(routeProfileId);
    } else if (profile) {
      setConnectionsCount(profile.total_connections || 0);
    }
  }, [routeProfileId, profile, contextId, fetchConnectionsCount]);

  const fetchFollowStatus = async () => {
    if (!profile?.id) return;

    let allResults = [];
    let url = `${BASE_URL}/user/follow-unfollow/follow/`;

    try {
      while (url) {
        const res = await axios.get(url, { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } });
        allResults = allResults.concat(res.data.results);
        url = res.data.next; // fetch next page if exists
      }

      const isFollowed = allResults.some(
        (item) => Number(item.follow_user_profile?.id) === Number(profile.id)
      );

      setIsFollowing(isFollowed);
    } catch (err) {
      console.error("Follow status error:", err);
    }
  };


  const toggleFollow = async () => {
    // Use the profile ID, not the user ID
    const targetProfileId = Number(profile?.id);
    if (!targetProfileId) {
      toast.error("Cannot follow this user: profile does not exist");
      return;
    }

    const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json", "x-api-key": process.env.REACT_APP_X_API_KEY };

    try {
      if (isFollowing) {
        // UNFOLLOW
        await axios.delete(`${BASE_URL}/user/follow-unfollow/follow/`, {
          headers,
          data: { id: targetProfileId },
        });
        setIsFollowing(false);
        toast.success("Unfollowed successfully");
      } else {
        // FOLLOW
        await axios.post(`${BASE_URL}/user/follow-unfollow/follow/`, { id: targetProfileId }, { headers });
        setIsFollowing(true);
        toast.success("Followed successfully");
      }
    } catch (err) {
      console.error("Follow/unfollow error:", err.response?.data || err);
      toast.error(err.response?.data?.error || "Error occurred");
    }
  };


  const handleConnect = async (id) => {
    const formData = new FormData();
    formData.append("friend_id", id);

    try {
      const response = await fetch(`${BASE_URL}/user/chat/connection-send/`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        setIsPending(true);
        toast.success("Request sent successfully");

        websocketClient.send(
          JSON.stringify({
            event: "notifications",
            type: "NEW_CONNECTION_REQUEST",
            recipientId: id,
            message: "You have a new connection request",
            payload: data,
          })
        );
      } else {
        console.error("Error sending request:", data);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };
  const fetchRequests = async () => {
    try {
      const incomingRes = await axios.get(
        `${BASE_URL}/user/chat/connections-request/`,
        { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } }
      );
      const incomingRequests = incomingRes.data || [];

      const outgoingRes = await axios.get(
        `${BASE_URL}/user/chat/connection-send/`,
        { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } }
      );
      const outgoingRequests = outgoingRes.data || [];

      setPendingRequests(incomingRequests);

      const isReceiver = incomingRequests.some(
        (req) =>
          req.to_user === Number(currentUserId) &&
          req.from_user === Number(profile.user) &&
          req.status === "pending"
      );
      setIsReceiver(isReceiver);

      const isPending =
        outgoingRequests.some(
          (req) =>
            req.from_user === Number(currentUserId) &&
            req.to_user === Number(profile.user) &&
            req.status === "pending"
        ) || isReceiver;
      setIsPending(isPending);
    } catch (error) {
      console.error("Error fetching connection requests:", error);
    }
  };

  const handleDecision = async (friendId, decision) => {
    console.log(friendId);
    try {
      const form = new FormData();
      form.append("friend_id", friendId);
      form.append("desision", decision);
      const res = await axios.post(
        `${BASE_URL}/user/chat/connections-request/`,
        form,
        {
          headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
        }
      );

      if (res.status === 200) {
        setPendingRequests((prev) =>
          prev.filter(
            (req) =>
              !(req.from_user === friendId && req.to_user === currentUserId)
          )
        );
        if (decision === "accept") setIsConnected(true);
        setIsReceiver(false);
        setIsPending(false);
        toast.success(`Request ${decision}ed successfully`);
        websocketClient.send(
          JSON.stringify({
            event: "notifications",
            type:
              decision === "accept"
                ? "CONNECTION_ACCEPTED"
                : "CONNECTION_REJECTED",
            recipientId: friendId,
            message:
              decision === "accept"
                ? "accepted your connection request"
                : "rejected your connection request",
            payload: res.data,
          })
        );
      }
    } catch (err) {
      console.error("Error handling decision:", err);
      toast.error("Failed to update request");
    }
  };

  const checkConnection = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/user/chat/check-connection/`, {
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
        params: { friend_id: profileId },
      });
      setIsConnected(res.data.connected || false);
    } catch (error) {
      console.error("Error checking connection:", error);
      setIsConnected(false);
    }
  };

  const handleRemoveConnection = async () => {
    try {
      const token = localStorage.getItem("access_token");
      await axios.post(
        `${BASE_URL}/user/chat/remove-connection/`,
        { friend_id: profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );

      setIsConnected(false);
      setIsPending(false);
      setIsReceiver(false);

      toast.success("Connection removed successfully");
    } catch (error) {
      console.error("Failed to remove connection", error);
      toast.error("Failed to remove connection");
    }
  };
  const handleNavigateChat = async () => {
    const targetProfileId = profileId;
    if (!targetProfileId || isYourOwnProfile) {
      toast.error("Cannot start chat with yourself.");
      return;
    }

    try {
      const res = await axios.get(`${BASE_URL}/user/chat/check-connection/`, {
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
        params: { friend_id: targetProfileId },
      });
      if (res.data.connected) {
        navigate("/chat", {
          state: {
            chatId: targetProfileId,
          },
        });
      } else {
        alert("You are not connected to that user. Please connect first.");
      }
    } catch (error) {
      console.error("Error checking connection:", error);
    }
  };
  const renderMedia = (article) => {
    switch (article.type) {
      case "video":
        return article.video ? (
          <div className="w-full">
            <video controls className="w-full rounded-[10px]">
              <source src={article.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : null;

      case "image":
        return article.image ? (
          <div className="w-full">
            <FileViewer
              publication_type="image"
              file={article.image}
              name={article.title || article.description || "Posted"}
            />
          </div>
        ) : null;

      case "publication":
        if (!article.upload_document) {
          return (
            <div className="w-full">
              <em>No document uploaded</em>
            </div>
          );
        }
        const fileName = article.upload_document.split("/").pop();
        const ext = fileName.split(".").pop().toLowerCase();

        let fileTypeLabel = "Document";
        if (ext === "pdf") fileTypeLabel = "PDF Document";
        else if (["doc", "docx"].includes(ext)) fileTypeLabel = "Word Document";
        else if (["xls", "xlsx"].includes(ext))
          fileTypeLabel = "Excel Spreadsheet";
        else if (["ppt", "pptx"].includes(ext))
          fileTypeLabel = "PowerPoint Presentation";
        else if (["txt"].includes(ext)) fileTypeLabel = "Text File";

        return (
          <div
            className="w-full flex items-center gap-2.5 p-2.5 rounded-lg cursor-pointer max-w-[1000px]"
            onClick={() =>
              navigate("/viewer", {
                state: {
                  url: article.upload_document,
                  title: article.title,
                  description: article.description,
                  abstract: article.abtsract,
                  type: "publication",
                  userId: article.user,
                  postId: article.id,
                  is_Liked: article.is_liked === true,
                  likeCount: article.total_likes,
                  commentCount: article.total_comments,
                },
              })
            }
          >
            <div className="w-full">
              {/* File Preview */}
              {["png", "jpg", "jpeg", "gif", "webp"].includes(ext) ? (
                <FileViewer
                  publication_type="image"
                  file={article.upload_document}
                  name={fileName}
                />
              ) : ext === "pdf" ? (
                <embed
                  src={`${article.upload_document}#toolbar=0&navpanes=0&scrollbar=0`}
                  type="application/pdf"
                  className="w-full h-[350px] rounded-md"
                />
              ) : (
                <iframe
                  src={`https://docs.google.com/gview?url=${article.upload_document}&embedded=true`}
                  className="w-full h-[350px] rounded-md overflow-hidden"
                  title="Document Preview"
                />
              )}

              {/* File Info Below */}
              <div className="mt-[8px]">
                <div
                  className="font-bold text-sm truncate"
                >
                  {fileName}
                </div>
                <div className="text-xs text-gray-600">
                  {fileTypeLabel}
                </div>
              </div>
            </div>
          </div>
        );

      case "code":
        return (
          <div className="w-full">
            <pre
              className="w-full h-[350px] max-h-[600px]  rounded-lg border border-gray-100 bg-gray-700 text-gray-100 font-mono text-sm whitespace-pre-wrap break-words overflow-auto">
              <CodeHighlighter codeHtml={article.code} padding='p-4' />
            </pre>
          </div>
        );


      case "post":
        return (
          <div >
            <div className="inline-flex items-center gap-2 mb-3   rounded">
              <h1 className="text-base sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-blue-900">
                {article.title}
              </h1>
            </div>

            <div>

              <div className="prose prose-sm max-w-none">
                <div
                  className="text-md text-gray-700 "
                  dangerouslySetInnerHTML={{
                    __html: article.content?.replace(/<\/?p>/g, ''),
                  }}
                />
              </div>
            </div>




            {article.post_type === "job" && (
              <div className="mt-6 border-t border-gray-100 pt-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* Header */}
                  <div className="col-span-1 sm:col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <h4 className="text-sm font-semibold text-gray-900">Job Details</h4>
                    </div>
                  </div>

                  {/* Left Column */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Job Title</p>
                        <p className="text-sm font-medium text-gray-900">{article.job_title}</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Company</p>
                        <p className="text-sm font-medium text-gray-900">{article.company_name}</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Location</p>
                        <p className="text-sm font-medium text-gray-900">{article.location}</p>
                      </div>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Salary</p>
                        <p className="text-sm font-medium text-gray-900">
                          {article.salary_min && article.salary_max
                            ? `${article.salary_min} - ${article.salary_max} ${article.currency}`
                            : "Not specified"}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Skills</p>
                        <p className="text-sm font-medium text-gray-900">
                          {Array.isArray(article.skills_required) && article.skills_required.length
                            ? article.skills_required.join(", ")
                            : article.skills_required || "Not specified"}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Experience</p>
                        <p className="text-sm font-medium text-gray-900">{getExperienceLabel(article.experience_level)}</p>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Section */}
                  <div className="col-span-1 sm:col-span-2 pt-4 border-t border-gray-100">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      {article.remote_allowed !== undefined && (
                        <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-xs text-gray-500">Remote Work</p>
                            <span className={`text-sm font-medium ${article.remote_allowed ? 'text-green-600' : 'text-gray-900'
                              }`}>
                              {article.remote_allowed ? "Allowed" : "Not allowed"}
                            </span>
                          </div>
                        </div>
                      )}

                      {article.qualifications && (
                        <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-xs text-gray-500">Qualifications</p>
                            <p className="text-sm font-medium text-gray-900">{article.qualifications}</p>
                          </div>
                        </div>
                      )}

                      {article.application_email && (
                        <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89-4.26a2 2 0 012.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-xs text-gray-500">Contact Email</p>
                            <p className="text-sm font-medium text-gray-900">{article.application_email}</p>
                          </div>
                        </div>
                      )}

                      {article.application_url && (
                        <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                          </div>
                          <div>
                            <p className="text-xs text-gray-500">Application URL</p>
                            <a
                              href={article.application_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-sm font-medium text-[#0f6abf] hover:underline"
                            >
                              View Application
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

            )}
          </div>
        );

      default:
        if (article.upload_document?.endsWith(".pdf")) {
          return (
            <div className="w-full">
              <iframe
                src={article.upload_document}
                title="PDF"
                className="w-full h-[350px] rounded-lg object-cover border border-gray-100"
              />
            </div>
          );
        } else if (article.upload_document) {
          return (
            <div className="w-full">
              <FileViewer
                publication_type="image"
                file={article.upload_document}
                name={article.title || "Uploaded document"}
              />
            </div>
          );
        } else {
          return (
            <div className="w-full">
              <div
                className="w-full h-[350px] rounded-lg object-cover border border-gray-100 flex justify-center items-center bg-gray-200 text-gray-600">
                <em>No media available</em>
              </div>
            </div>
          );
        }
    }
  };

  if (loading)
    return (
      <div>
        {isMobile ? <MobileHeader hideHamburger={true} /> : <Header />}
        <div
          className="fixed w-screen h-screen flex justify-center items-center z-[9999]">
          <ClipLoader size={50} color={"#4A90E2"} />
        </div>
      </div>
    );

  return (
    <div >
      {isMobile ? (
        <MobileHeader hideHamburger={true} hideFilter={true} />
      ) : (
        <Header hideFilter={true} />
      )}
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
        className="relative w-full max-w-full h-full min-h-[235px] flex flex-col flex-wrap justify-center p-0 bg-center bg-cover bg-no-repeat before:content-[''] before:absolute before:inset-0 before:bg-white/20 before:pointer-events-none"
      >

        {apiError ? (
          <p className="text-red-500">{apiError}</p>
        ) : profile ? (
          <>
            <div className="w-full max-w-[1024px] pt-5 pb-0 mx-auto mt-0 flex flex-col relative rounded-t-[10px]">
              <div className="w-full h-[180px] md:h-[220px] lg:h-[250px] mb-[-85px] sm:mb-[-95px] lg:mb-[-105px] rounded-xl overflow-hidden relative">
                {isYourOwnProfile && (
                  <div className="absolute top-3 sm:top-4 right-3 sm:right-4 z-10">
                    <label
                      htmlFor="cover-upload"
                      className="w-10 h-10 sm:w-12 sm:h-12 bg-white/80 backdrop-blur-sm rounded-lg sm:rounded-xl flex justify-center items-center cursor-pointer hover:bg-white hover:shadow-md transition-all border border-white/50"
                    >
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#e8f0f7] rounded-md sm:rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                    </label>
                    <input
                      type="file"
                      id="cover-upload"
                      className="hidden"
                      accept="image/*"
                      onChange={handleCoverUpload}
                    />
                  </div>
                )}
                <img
                  src={profile.cover_image || AdminImg}
                  alt="User profile"
                  className="w-full h-full object-cover object-center"
                />
              </div>

              <div className="w-full max-w-[1024px] px-0 py-[15px_0px] sm:py-[20px_0px] pb-0 mx-auto mt-0 flex flex-col relative rounded-[10px_10px_0px_0px]">
                <div className="flex relative pl-4 sm:pl-6 w-full max-w-fit mb-[-55px] sm:mb-[-65px]">
                  <div className="relative">
                    {profile?.profile_picture ? (
                      <img
                        src={profile.profile_picture}
                        alt="User profile"
                        className="w-[100px] h-[100px]  rounded-full object-cover border-3 sm:border-4 border-white shadow-lg"
                      />
                    ) : (
                      <div className="w-[100px] h-[100px] rounded-full bg-[#e8f0f7] border-3 sm:border-4 border-white shadow-lg flex items-center justify-center">
                        <svg className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                      </div>
                    )}
                    <div
                      className={`absolute -bottom-0 -right-1 w-5 h-5 rounded-full border-2 border-white ${profile?.is_online ? 'bg-green-500' : 'bg-gray-400'
                        }`}
                    />

                  </div>
                </div>

                <div className="flex flex-col w-full p-3 sm:p-4 pl-4 sm:pl-7 gap-3 sm:gap-4 rounded-t-[10px] bg-white text-gray-900">
                  {isEditOpen && isYourOwnProfile && (
                    <>
                      {/* Overlay */}
                      <div className="fixed top-0 left-0 w-full h-full bg-[rgba(50,50,50,0.5)] z-[1000]"></div>

                      {/* Dropdown */}
                      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1010] w-[90%] max-w-[650px] bg-white  rounded-[10px] sm:rounded-[12px] max-h-[90vh] overflow-y-auto">
                        <EditYourProfile
                          onClose={() => {
                            setIsEditOpen(false);
                            fetchProfile();
                          }}
                          mode={editMode}
                        />
                      </div>
                    </>
                  )}

                  <div className="pl-[110px]">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full mb-3 gap-3 sm:gap-0">
                      <div className="w-full">
                        <h2 className="text-lg sm:text-xl font-semibold text-gray-900">{profile.name}</h2>
                        <div className="flex items-center gap-2 sm:gap-3 mt-2">
                          {profile.research_areas && (
                            <div className="flex flex-wrap gap-1 sm:gap-2">
                              {profile.research_areas.split(',').slice(0, 3).map((area, index) => (
                                <span
                                  key={index}
                                  className="text-[10px] xs:text-xs px-2 py-0.5 sm:px-3 sm:py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-md sm:rounded-lg font-medium"
                                >
                                  {area.trim()}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center gap-2 sm:gap-3">
                        {routeProfileId && !isYourOwnProfile ? (
                          <button
                            className="px-3 py-1.5 sm:px-4 sm:py-2 bg-[#0f6abf] text-white text-xs sm:text-sm font-medium rounded-lg sm:rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-1 sm:gap-2"
                            onClick={handleNavigateChat}
                          >
                            <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            <span className="nowrap" style={{ whiteSpace: 'nowrap' }}>Chat</span>
                          </button>
                        ) : null}
                        {/* Teacher Profile Button */}
                        {((!routeProfileId && is_Teacher) || (routeProfileId && isTeacher)) ? (
                          <button
                            className="px-3 py-1.5 sm:px-4 sm:py-2 bg-[#0f6abf] text-white text-xs sm:text-sm font-medium rounded-lg sm:rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-1 sm:gap-2"
                            onClick={() => navigate(!routeProfileId ? `/teacher-profile/${teacher?.id}` : `/teacher-profile/${teacherId}`)}
                          >
                            <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                            <span className="nowrap" style={{ whiteSpace: 'nowrap' }}>Teacher Profile</span>
                          </button>
                        ) : null}


                        {/* Edit Button (Own Profile) */}
                        {isYourOwnProfile && (
                          <button
                            className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white border border-gray-300 text-gray-700 rounded-lg sm:rounded-xl hover:border-[#0f6abf] hover:text-[#0f6abf] transition-all"
                            onClick={() => {
                              setEditMode("fullProfile");
                              setIsEditOpen(true);
                            }}
                          >
                            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                        )}

                        {/* Follow Button (Other Profile) */}
                        {routeProfileId && !isYourOwnProfile && (
                          <button
                            className={`px-3 py-1.5 sm:px-5 sm:py-2 text-xs sm:text-sm font-medium rounded-lg sm:rounded-xl transition-colors ${isFollowing
                                ? "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                : "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
                              }`}
                            onClick={toggleFollow}
                          >
                            {isFollowing ? (
                              <div className="flex items-center gap-1 sm:gap-2">
                                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 12H6" />
                                </svg>
                                <span >Unfollow</span>

                              </div>
                            ) : (
                              <div className="flex items-center gap-1 sm:gap-2">
                                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                </svg>
                                <span>Follow</span>
                              </div>
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="w-full flex justify-center">
                    <div className="bg-[#dfefff] rounded-xl sm:rounded-2xl p-4 sm:p-5 lg:p-6 w-full space-y-3 sm:space-y-4">
                      {/* Degree */}
                      {profile.degree && (
                        <div className="flex items-center gap-2">
                          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                          <p className="text-sm sm:text-base font-semibold text-[#0f6abf]">{profile.degree}</p>
                        </div>
                      )}

                      {/* Objective, Offering, Domain */}
                      {[profile.objective, profile.offering, profile.domain].map(
                        (item, index) =>
                          item && (
                            <div key={index} className="flex items-start gap-2">
                              <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                              </svg>
                              <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">{item}</p>
                            </div>
                          )
                      )}

                      {/* Primary Affiliation */}
                      {profile.primary_affiliation && (
                        <div className="pt-2 sm:pt-3 border-t border-gray-200">
                          <div className="flex items-center gap-2 mb-1 sm:mb-2">
                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                            <p className="text-xs sm:text-sm font-medium text-gray-900">{profile.primary_affiliation}</p>
                          </div>
                        </div>
                      )}

                      {/* Current Activity */}
                      {profile.current_activity && (
                        <div className="flex items-start gap-2">
                          <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <p className="text-xs sm:text-sm text-gray-700 leading-relaxed">{profile.current_activity}</p>
                        </div>
                      )}
                      {/* <div className="pt-2 sm:pt-3 border-t border-gray-200">
  <div className="flex items-center gap-2 mb-1 sm:mb-2">
    <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
    <p className="text-xs sm:text-sm font-medium text-gray-900">
      {profile.followers_count || 0} followers • {profile.connections_count || 0} connections
    </p>
  </div>
</div> */}
                      {/* Followers */}
                      {displayFollowersCount > 0 && (
                        <div className="pt-2 sm:pt-3 border-t border-gray-200">
                          <button
                            onClick={() => {
                              const targetProfileId = routeProfileId || contextId;
                              fetchFollowers(targetProfileId);
                              setShowFollowersModal(true);
                            }}
                            className="flex items-center gap-2 mb-1 sm:mb-2 hover:opacity-80 transition-opacity cursor-pointer w-full"
                          >
                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                            <p className="text-xs sm:text-sm font-medium text-gray-900">
                              {displayFollowersCount} followers
                            </p>
                          </button>
                        </div>
                      )}

                      {(routeProfileId ? connectionsCount : profile.total_connections) > 0 && (
                        <div className="pt-2 sm:pt-3 border-t border-gray-200">
                          <button
                            onClick={() => {
                              const targetProfileId = routeProfileId || contextId;
                              fetchConnections(targetProfileId);
                              setShowConnectionsModal(true);
                            }}
                            className="flex items-center gap-2 mb-1 sm:mb-2 hover:opacity-80 transition-opacity cursor-pointer w-full"
                          >
                            <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gray-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            <p className="text-xs sm:text-sm font-medium text-gray-900">
                              {routeProfileId ? connectionsCount : profile.total_connections || 0} connections
                            </p>
                          </button>
                        </div>
                      )}


                      {/* Bio */}
                      {profile.bio && (
                        <div className="w-full pt-3 sm:pt-4 mt-3 sm:mt-4 border-t border-gray-200">
                          <div className="flex items-center gap-2 mb-2 sm:mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <h4 className="text-xs sm:text-sm font-semibold text-gray-900">About</h4>
                          </div>
                          <p className="text-sm sm:text-base text-gray-800 leading-relaxed">{profile.bio}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Followers Modal */}
            {showFollowersModal && (
              <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl max-w-md w-full max-h-[80vh] overflow-y-auto shadow-2xl">
                  <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex justify-between items-center rounded-t-2xl">
                    <h2 className="text-lg font-semibold text-gray-900">Followers</h2>
                    <button
                      onClick={() => setShowFollowersModal(false)}
                      className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-lg transition-colors"
                    >
                      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="p-4">
                    {followersLoading ? (
                      <div className="flex justify-center py-8">
                        <div className="w-6 h-6 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : followersList.length === 0 ? (
                      <div className="text-center py-8">
                        <svg className="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                        <p className="text-gray-500 text-sm">No followers yet</p>
                      </div>
                    ) : (
                      <div className="space-y-3">
                        {followersList.map((follower) => (
                          <button
                            key={follower.id}
                            onClick={() => {
                              navigate(`/profile-view/${follower.id}`);
                              setShowFollowersModal(false);
                            }}
                            className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-xl transition-colors text-left"
                          >
                            <div className="relative flex-shrink-0">
                              {follower.profile_picture ? (
                                <img
                                  src={follower.profile_picture}
                                  alt={follower.name}
                                  className="w-12 h-12 rounded-full object-cover"
                                />
                              ) : (
                                <div className="w-12 h-12 rounded-full bg-[#e8f0f7] flex items-center justify-center">
                                  <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                  </svg>
                                </div>
                              )}
                              <div className={`absolute -bottom-0 -right-1 w-3 h-3 rounded-full border-2 border-white ${follower.is_online ? 'bg-green-500' : 'bg-gray-400'}`} />
                            </div>

                            <div className="flex-1 min-w-0">
                              <h3 className="text-sm font-semibold text-gray-900 truncate">{follower.name}</h3>
                              <p className="text-xs text-gray-500 truncate">{follower.primary_affiliation || follower.institution || 'No affiliation'}</p>
                            </div>

                            <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* Connections Modal */}
            {showConnectionsModal && (
              <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl max-w-md w-full max-h-[80vh] overflow-y-auto shadow-2xl">
                  <div className="sticky top-0 bg-white border-b border-gray-200 p-4 flex justify-between items-center rounded-t-2xl">
                    <h2 className="text-lg font-semibold text-gray-900">Connections</h2>
                    <button
                      onClick={() => setShowConnectionsModal(false)}
                      className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-lg transition-colors"
                    >
                      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="p-4">
                    {connectionsLoading ? (
                      <div className="flex justify-center py-8">
                        <div className="w-6 h-6 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : connectionsList.length === 0 ? (
                      <div className="text-center py-8">
                        <svg className="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                        <p className="text-gray-500 text-sm">No connections yet</p>
                      </div>
                    ) : (
                      <div className="space-y-3">
                        {connectionsList.map((conn) => (
                          <button
                            key={conn.id}
                            onClick={() => {
                              navigate(`/profile-view/${conn.id}`);
                              setShowConnectionsModal(false);
                            }}
                            className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-xl transition-colors text-left"
                          >
                            <div className="relative flex-shrink-0">
                              {conn.profile_picture ? (
                                <img
                                  src={conn.profile_picture}
                                  alt={conn.name}
                                  className="w-12 h-12 rounded-full object-cover"
                                />
                              ) : (
                                <div className="w-12 h-12 rounded-full bg-[#e8f0f7] flex items-center justify-center">
                                  <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                  </svg>
                                </div>
                              )}
                              <div className={`absolute -bottom-0 -right-1 w-3 h-3 rounded-full border-2 border-white ${conn.is_online ? 'bg-green-500' : 'bg-gray-400'}`} />
                            </div>

                            <div className="flex-1 min-w-0">
                              <h3 className="text-sm font-semibold text-gray-900 truncate">{conn.name}</h3>
                              <p className="text-xs text-gray-500 truncate">{conn.institution || conn.primary_affiliation || 'No affiliation'}</p>
                            </div>

                            <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : null}
        {!loading && profile && (
          <div className="w-full max-w-[1024px] flex justify-between gap-2 p-2 bg-white rounded-b-xl mx-auto">
            <div className="flex gap-2 overflow-x-auto scrollbar-hidden">
              {/* All */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "all"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("all");
                  setSearchParams({ tab: "all" });
                }}
              >
                All
              </button>

              {/* Publications */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "publications"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("publications");
                  setSearchParams({ tab: "publications" });
                }}
              >
                Publications
              </button>

              {/* Gallery */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "gallery"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("gallery");
                  setSearchParams({ tab: "gallery" });
                }}
              >
                Gallery
              </button>

              {/* Videos */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "videos"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("videos");
                  setSearchParams({ tab: "videos" });
                }}
              >
                Videos
              </button>

              {/* Code */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "code"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("code");
                  setSearchParams({ tab: "code" });
                }}
              >
                Code
              </button>

              {/* Portfolio */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "portfolio"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("portfolio");
                  setSearchParams({ tab: "portfolio" });
                }}
              >
                Portfolio
              </button>

              {/* Invitations */}
              {isYourOwnProfile && (
                <button
                  className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "invitations"
                      ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                      : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                    }`}
                  onClick={() => {
                    setSelectedTab("invitations");
                    setSearchParams({ tab: "invitations" });
                  }}
                >
                  Invitations
                </button>
              )}

              {/* Posts */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "posts"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("posts");
                  setSearchParams({ tab: "posts" });
                }}
              >
                Posts
              </button>

              {/* Jobs */}
              <button
                className={`flex-shrink-0 max-w-[130px] h-[40px] px-7 py-3 text-sm font-medium rounded-[30px] border transition-all duration-200 flex items-center justify-center ${selectedTab === "jobs"
                    ? "bg-[#0f6abf] border-[#0f6abf] text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-b-[#0f6abf]"
                  }`}
                onClick={() => {
                  setSelectedTab("jobs");
                  setSearchParams({ tab: "jobs" });
                }}
              >
                Jobs
              </button>
            </div>

            {/* Connection Button */}
            {routeProfileId && !isYourOwnProfile && (
              <div className="flex items-center gap-2">
                {isConnected ? (
                  <button
                    className="flex items-center gap-1 px-4 py-2 bg-green-100 text-green-700 text-sm font-medium rounded-xl hover:bg-green-200 transition-colors"
                    onClick={() => handleRemoveConnection(profileId)}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    Connected
                  </button>
                ) : isPending ? (
                  isReceiver ? (
                    <div className="flex gap-2">
                      <button
                        className="flex items-center gap-1 px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
                        onClick={() => handleDecision(profileId, "accept")}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                        Accept
                      </button>
                      <button
                        className="flex items-center gap-1 px-4 py-2 bg-red-100 text-red-600 text-sm font-medium rounded-xl hover:bg-red-200 transition-colors"
                        onClick={() => handleDecision(profileId, "reject")}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    <button disabled className="flex items-center gap-1 px-4 py-2 bg-gray-100 text-gray-400 text-sm font-medium rounded-xl cursor-not-allowed">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                      </svg>
                      Pending
                    </button>
                  )
                ) : (
                  <button
                    className="flex items-center gap-1 px-4 py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-xl hover:border-[#0f6abf] hover:text-[#0f6abf] transition-colors"
                    onClick={() => handleConnect(profileId)}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                    </svg>
                    Connect
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      {/*  TAB CONTENT GOES HERE */}
      <div className="w-full min-h-[70vh] mt-6">
        {!loading && profile && (
          <div className="w-full  mx-auto flex flex-col items-center gap-6 pb-12 px-1 md:px-4 ">

            {/* CONTENT */}
            <div className="w-full flex flex-col items-center">

              {/* TABS */}
              {selectedTab === "publications" && profileId && (
                <Publication isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "gallery" && profileId && (
                <Gallery isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "videos" && profileId && (
                <Video isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "code" && profileId && (
                <Code isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "portfolio" && profileId && (
                <Portfolio isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "invitations" && profileId && (
                <Invitations isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "posts" && profileId && (
                <Posts isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}
              {selectedTab === "jobs" && profileId && (
                <Jobs isYourOwnProfile={isYourOwnProfile} profileId={profileId} />
              )}

              {/* ALL POSTS */}
              {selectedTab === "all" && (
                <div className="w-full">

                  {allLoading ? (
                    <></>
                  ) : allPosts.length === 0 ? (
                    <div className="text-center py-16">
                      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </div>
                      <p className="text-gray-500">No posts yet</p>
                    </div>
                  ) : (
                    <div className="space-y-6 w-full max-w-5xl mx-auto">

                      {allPosts.map((post) => (
                        <div key={post.id} className="w-full">

                          {/* EDIT MODAL */}
                          {isEditing && editingPostId === post.id && (
                            <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6 shadow-sm">
                              <textarea
                                value={editText}
                                onChange={(e) => setEditText(e.target.value)}
                                rows="4"
                                placeholder="Edit your description..."
                                className="w-full border border-gray-300 rounded-xl p-4 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                              />

                              {post.type === "publication" && (
                                <div className="mt-4">
                                  <label className="block text-sm font-medium text-gray-700 mb-2">Sharing Options</label>
                                  <select
                                    value={editVisibility}
                                    onChange={(e) => setEditVisibility(e.target.value)}
                                    className="w-full border border-gray-300 rounded-xl p-3 text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                                  >
                                    <option value="public">Public</option>
                                    <option value="private">Private</option>
                                  </select>
                                </div>
                              )}

                              <div className="flex gap-3 mt-6">
                                <button
                                  onClick={() => setIsEditing(false)}
                                  className="flex-1 py-2.5 border border-gray-300 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors"
                                >
                                  Cancel
                                </button>

                                <button
                                  onClick={handleSaveEdit}
                                  disabled={loading}
                                  className="flex-1 py-2.5 bg-[#0f6abf] text-white rounded-xl text-sm font-medium hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                                >
                                  {loading ? (
                                    <>
                                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                      Saving...
                                    </>
                                  ) : (
                                    "Save Changes"
                                  )}
                                </button>
                              </div>
                            </div>
                          )}
                          <div className=" w-full flex justify-between mb-6">
                            {isYourOwnProfile && (
                              <DropdownActions
                                type={post.type}
                                onEdit={() => {
                                  if (post.post_type === "job") {
                                    dropdownRefs.current[post.id]?.handleEditJob?.();
                                  } else {
                                    handleEditClick(post);
                                  }
                                }}
                                onDelete={() =>
                                  handleDeletePost(post.id, post.type)
                                }
                              />
                            )}
                          </div>
                          {/* POST */}
                          <ResearchSuggestionDropdown
                            ref={(el) => (dropdownRefs.current[post.id] = el)}
                            postId={post.id}
                            post_type={post.post_type || "normal"}
                            type={post.type}
                            bodyDescription={post.description}
                            title={post.title}
                            abstract={post.abstract}
                            author={post.author}
                            reads={post.reads}
                            likeCount={post.total_likes}
                            commentCount={post.total_comments}
                            is_Liked={post.is_liked}
                            disableNavigation={true}
                            hideUserInfo={true}
                            collaborators={post.collaborators}
                            hideReads={true}
                            currentUser={currentUser}
                            currentUserId={currentUserId}
                            authorId={post.user}
                            onDelete={() => handleDeletePost(post.id, post.type)}
                            showExternalLink={false}
                            jobData={post.post_type === "job" ? post : null}
                            mediaPreview={
                              <div >

                                {/* HEADER */}


                                {/* MEDIA */}
                                <div >
                                  {renderMedia(post)}
                                </div>

                              </div>
                            }
                          />
                        </div>
                      ))}

                    </div>
                  )}

                  {/* INFINITE SCROLL */}
                  <div
                    ref={loaderRef}
                    className="text-center py-8"
                  >
                    {allLoading || loading ? (
                      <div className="flex justify-center">
                        <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : (
                      !hasMore && <div className="h-4"></div>
                    )}
                  </div>

                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default ProfileView;